import { DealProgressStates } from '@/types/deal-progress';

export class StepManagerState {
	dealProgressStatus: DealProgressStates | null = null

	isLoading = false;
}
